var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container page404"},[_c('img',{attrs:{"src":require("../assets/images/404.png")}}),_c('p',[_vm._v("您所访问的页面不存在了")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("返回首页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }